import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage";
import * as jsPDF from 'jspdf';
import { EISAI_LOGO } from '../../providers/images';
import { DatabaseProvider } from '../database/database';
import moment from 'moment';
import { PatientProvider } from '../patient/patient';

@Injectable()
export class PdfProvider {

  pdf: any;
  pageHeight: number;
  pageWidth: number;
  pageNumber: number = 0;
  startx: number = 40;
  starty: number = 40;
  x: number = 40;
  y: number = 40;
  supplies: any[];

  clinic: any;

  task: AngularFireUploadTask;
  filepath: any;

  constructor(private afStorage: AngularFireStorage, private database: DatabaseProvider, private db: PatientProvider) {
  }

  public createLetter(program_id, program_name, patient, letter_type, custom_text, user)  {
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pdf.deletePage(1);

    return new Promise((resolve, reject) => {
      const start = async () => {
        if (letter_type === 'Reimbursement Status Update')  {
          await this.reimbursementLetter(program_name, patient, custom_text);
        } else if (letter_type === 'Enrolment Form Received Confirmation') {
          await this.enrolmentReceived(program_name, patient, null);
        } else if (letter_type === 'Prescription Renewal Request') {
          await this.rxRenewal(program_name, patient, null);
        } else if (letter_type === 'Special Authorization Request') {
          await this.saRequest(program_name, patient, null);
        } else if (letter_type === 'Patient’s Coverage Secured') {
          await this.coverageSecured(program_name, patient, null);
        } else if (letter_type === 'Patient’s Coverage Denied') {
          await this.coverageDenied(program_name, patient, custom_text);
        } else if (letter_type === 'Unable to Contact Patient') {
          await this.unableToContact(program_name, patient, custom_text);
        } else if (letter_type === 'Patient Has Declined to Enrol') {
          await this.declinedEnrolment(program_name, patient, custom_text);
        } else if (letter_type === 'Notice of Discontinuation') {
          await this.discontinuationNotice(program_name, patient, custom_text);
        } else if (letter_type === 'Missing Information') {
          await this.missingInformation(program_name, patient, custom_text);
        } else if (letter_type === 'Medical Clarification') {
          await this.medicalClarification(program_name, patient, custom_text);
        } else {
          reject('Letter not found');
        }
        console.log('done pdf');
        // this.pdf.save('test.pdf');
        // resolve('test');
        const file = this.pdf.output("blob")
        const filepath = await this.uploadLettertoFirebase(program_id, program_name, patient, file, letter_type, user);
        console.log('Finished Everything, here is the file: ', filepath);
        resolve(filepath);
      }
      start();
    });
  }

  private async reimbursementLetter(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `We are currently in the process of securing coverage of the medication ${patient.therapy}® for ${patient.first_name + ' ' + patient.last_name}. At this time, we are currently waiting for: `;
      const paragraph3 = custom_text;
      const paragraph4 = `We will inform you once coverage of ${patient.therapy}® has been determined for ${patient.first_name + ' ' + patient.last_name}.  Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('REIMBURSEMENT STATUS UPDATE', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      this.y += 15;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      let para3 = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para3.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para3); this.y += 25;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(12);
      this.y += textheight;

      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async enrolmentReceived(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `Please accept this letter as a confirmation that we have received the Enrolment form and are currently in the process of contacting ${patient.first_name + ' ' + patient.last_name}. Once the enrollment has been completed, the program will provide you with an update.`;
      const paragraph3 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Confirmation – Enrollment Form Received', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async rxRenewal(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `Please note that the program has been advised by the pharmacy that they have used ${patient.first_name + ' ' + patient.last_name} last refill for ${patient.therapy}® and will require a new prescription.  Attached is a copy of the prescription. We asked that you kindly review and complete the following and return to the program via fax or email:`;
      const paragraph3 = `Once we receive the completed form, we will then forward the prescription to the pharmacy on behalf of the patient.`;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Prescription Renewal', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('•	dose', this.x + 50, this.y); this.y += 15;
      this.pdf.text('•	refill', this.x + 50, this.y); this.y += 15;
      this.pdf.text('•	signature and date', this.x + 50, this.y); this.y += 30;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async saRequest(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `Please be advised that  ${patient.first_name + ' ' + patient.last_name} private insurance company requires a we complete a special authorization request form requesting coverage of ${patient.therapy}®. We have completed as much of the form as possible with the information available and highlighted the areas that remain incomplete.  We ask that you kindly review, complete, sign and date the form and return it to the program via fax to 1-844-980-0416.`;
      const paragraph3 = `Once we have received the completed document, the program will forward the request to ${patient.first_name + ' ' + patient.last_name}’s insurer for review.  We will update you once a decision has been made. `;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Special Authorization Request', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 25 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async coverageSecured(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `The Eisai Cares Patient Support Program is pleased to advise you that coverage has been secured for ${patient.first_name + ' ' + patient.last_name} and the medication ${patient.therapy}®.  ${patient.first_name + ' ' + patient.last_name} has been notified and the pharmacy has received the updated information.`;
      const paragraph2 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Patient’s Coverage Secured', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 25 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 40 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async coverageDenied(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `We are contacting you to advise that ${patient.first_name + ' ' + patient.last_name} has received a denial from his/her private insurer following the request for coverage of his/her ${patient.therapy}® medication for the following reason(s):`;
      const paragraph3 = `We strongly believe there is an opportunity to appeal their decision by providing them with additional information.`;
      const paragraph4 = `To be of assistance, we have created an appeal letter template for you to review and update.  We ask that you kindly provide any supporting clinical information that could help with securing coverage. Once completed, kindly sign, date and return the letter to the Eisai Cares Patient Support Program and we will forward to the patient’s public/private insurer for review.`;
      const paragraph5 = `The Eisai Cares Patient Support Program will follow up accordingly with the patient’s insurer and will provide you with an update once a response has been received.`;
      const paragraph6 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`; 

      await this.addNewPage(program_name);
    
      this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Patient’s Coverage Denied', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 35;
      this.pdf.setFontSize(26);
      this.pdf.text('FAX', this.x, this.y); this.y += 30;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;

      this.pdf.setFontType("normal");

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 25;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(11);
      this.pdf.setFontType("normal");
      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      para = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para); this.y += 20 + textheight;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(11);
      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph5, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph6, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program - info@eisaicares.ca', this.x, this.y); this.y += 15;
      resolve('Finished Letter');
    });
  }

  private async unableToContact(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Please be advised that after several attempts, we have been unsuccessful in reaching ${patient.first_name + ' ' + patient.last_name}.`;
      const paragraph2 = `The number(s) we have on file is, ${patient.program_patient_id}. If you have an alternate contact number and/or email address, kindly forward to us via fax, phone or email.  If no other contact information is available at this time, kindly request the patient to contact the program directly at 1-844-980-0410.`;
      const paragraph3 = `Please note, we have placed ${patient.first_name + ' ' + patient.last_name}’s file ON HOLD until the program receives updated contact information or if further instructions have been provided by your office.`;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Unable to Contact Patient', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async declinedEnrolment(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `We wish to inform you that we have contacted ${patient.first_name + ' ' + patient.last_name} and attempted to complete their enrolment into the Eisai Cares Patient Support Program. Unfortunately, ${patient.first_name + ' ' + patient.last_name} has declined to enroll in the program for the following reason(s):`;
      const paragraph3 = `We have closed ${patient.first_name + ' ' + patient.last_name}'s file but if at any time the patient wishes to move forward with the enrolment, kindly have him/her contact the program and we will be more than happy to proceed. `;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`; 

      await this.addNewPage(program_name);
    
      this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Patient Has Declined to Enrol', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 35;
      this.pdf.setFontSize(26);
      this.pdf.text('FAX', this.x, this.y); this.y += 30;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;

      this.pdf.setFontType("normal");

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 25;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(11);
      this.pdf.setFontType("normal");
      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      para = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para); this.y += 20 + textheight;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(11);

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program - info@eisaicares.ca', this.x, this.y); this.y += 15;
      resolve('Finished Letter');
    });
  }

  private async discontinuationNotice(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `We are contacting you to inform you that ${patient.first_name + ' ' + patient.last_name} has decided to discontinue his/her ${patient.therapy} treatment for the following reason(s):`;
      const paragraph3 = `We have encouraged the patient to follow up with your office in order to further discuss his/her treatment options.  Please note we have closed ${patient.first_name + ' ' + patient.last_name}’s file but it can be reopened at any time.`;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`; 

      await this.addNewPage(program_name);
    
      this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Notice of Discontinuation', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 35;
      this.pdf.setFontSize(26);
      this.pdf.text('FAX', this.x, this.y); this.y += 30;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;

      this.pdf.setFontType("normal");

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 25;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(11);
      this.pdf.setFontType("normal");
      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      para = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para); this.y += 20 + textheight;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(11);

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program - info@eisaicares.ca', this.x, this.y); this.y += 15;
      resolve('Finished Letter');
    });
  }

  private async missingInformation(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `We have received the enrollment form for ${patient.first_name + ' ' + patient.last_name} and upon review, missing information was noted. `;
      const paragraph3 = `For your convenience, we have highlighted the fields required in order to complete the enrolment. ${patient.first_name + ' ' + patient.last_name} file has been placed on hold further notice from your office.  We kindly ask that you send us the information via fax or email at your earliest convenience.`;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Missing Information', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async medicalClarification(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      const paragraph1 = `Thank you for referring ${patient.first_name + ' ' + patient.last_name} to the Eisai Cares Patient Support Program.`;
      const paragraph2 = `The Eisai Cares Patient Support Program is a program available to patient who have been diagnosed with ${custom_text} as a Health Canada Indication. The Eisai Cares Program has received ${patient.first_name + ' ' + patient.last_name}’s enrollment form and based on the information received, ${patient.first_name + ' ' + patient.last_name} does not meet the eligibility criteria.`;
      const paragraph3 = `Kindly confirm ${patient.first_name + ' ' + patient.last_name}’s diagnosis and update accordingly on the attached enrolment form.`;
      const paragraph4 = `Please do not hesitate to contact the program should you have any questions.  The program is available from Monday-Friday; 8am-8pm EST, excluding holidays.`;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Medical Clarification', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('FAX', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('To: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('From: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Fax: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 25 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincerely,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Nurse Case Manager', this.x, this.y); this.y += 15;
      this.pdf.text('Eisai Cares Patient Support Program', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  public createOrder(program_id, program_name, patient, order, user) {
    console.log('Creating order for order: ', patient, order);
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pdf.deletePage(1);

    return new Promise((resolve, reject) => {
      const start = async () => {
        await this.addOrder(program_name, patient, order);
        console.log('done pdf');
        // this.pdf.save('test.pdf');
        // resolve('test');
        const file = this.pdf.output("blob")
        const filepath = await this.uploadOrdertoFirebase(program_id, program_name, patient, file, 'Order', order.order_number, user);
        console.log('Finished Everything, here is the file: ', filepath);
        resolve(filepath);
      }
      start();
    });
  }

  private async addOrder(program_name, patient, order)  {
    return new Promise(async (resolve, reject) => {
      
      await this.addNewPage('DISTRIBUTORS - Insert a copy with shipment - Enrolment Form Attached');

      // Header
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      if (order.type === 'Drug') {
        this.pdf.text(order.commercial_compassionate + ' Order - ' + order.order_number, this.pageWidth / 2, this.y, 'center'); this.y += 5;
      } else {
        this.pdf.text(order.type + ' - ' + order.order_number, this.pageWidth / 2, this.y, 'center'); this.y += 5;
      }
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Date
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x, this.y); this.y += 15;

      // NCM
      this.pdf.text('Case Worker: ' + patient.case_manager, this.x, this.y); this.y += 15;

      // NCM
      this.pdf.text('Order Number: ' + order.order_number, this.x, this.y); this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;

      this.pdf.setFontType("bold");
      this.pdf.text('Patient', this.x, this.y);
      this.pdf.text('Physician', this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text('Pharmacy', this.x + 400, this.y); 
      this.y += 15;

      this.pdf.setFontType("normal");
      this.pdf.text(patient.first_name + ' ' + patient.last_name, this.x, this.y);
      this.pdf.text('Dr. ' + order.doctor.first_name + ' ' + order.doctor.last_name, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.name, this.x + 400, this.y); 
      this.y += 15;

      this.pdf.text(patient.address, this.x, this.y);
      if (order.doctor.address) this.pdf.text(order.doctor.address, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.address, this.x + 400, this.y); this.y += 15;

      this.pdf.text(patient.city + ', ' + patient.province, this.x, this.y);
      if (order.doctor.address) this.pdf.text(order.doctor.city + ', ' + order.doctor.province, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.city + ', ' + order.pharmacy.province, this.x + 400, this.y); this.y += 15;

      this.pdf.text(patient.postal_code, this.x, this.y);
      if (order.doctor.address) this.pdf.text(order.doctor.postal_code, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.postal_code, this.x + 400, this.y); this.y += 15;

      if (patient.dob) this.pdf.text('DOB: ' + moment(patient.dob.seconds * 1000).format('MMM-DD-YYYY'), this.x, this.y);
      if (order.doctor.fax_number) this.pdf.text('FAX: ' + order.doctor.fax_number, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text('FAX: ' + order.pharmacy.fax_number, this.x + 400, this.y); 
      this.y += 15;
      
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;

      // Therapy and Indication
      if (order.type === 'Drug') {
        if (patient.therapy) this.pdf.text('Therapy: ' + patient.therapy + ' - ' + order.commercial_compassionate, this.x, this.y); this.y += 15;
        if (patient.indication) this.pdf.text('Indication: ' + patient.indication, this.x, this.y); this.y += 15;
        this.pdf.text('Dose: ' + order.dose, this.x, this.y); this.y += 15;
        this.pdf.text('Repeats: ' + order.repeats, this.x, this.y); this.y += 15;
        this.pdf.text('Quantity: ' + order.quantity, this.x, this.y); this.y += 15;
      } else {
        this.pdf.text(order.type, this.x, this.y); this.y += 15;
        if (patient.therapy) this.pdf.text('Therapy: ' + patient.therapy, this.x, this.y); this.y += 15;
        if (patient.indication) this.pdf.text('Indication: ' + patient.indication, this.x, this.y); this.y += 15;
      }

      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;
      this.pdf.setFontType("bold");
      this.pdf.text('Instructions', this.x, this.y); this.y += 15;

      this.pdf.setFontType("normal");
      if (order.notes)  {
        let notes = this.pdf.splitTextToSize(order.notes, this.pageWidth - 100);
        this.pdf.text(this.x, this.y, notes); this.y += 25;
      }
      resolve('Finished Order Contents');
    });
  }

  private async addNewPage(program_name) {
    return new Promise(async (resolve, reject) => {
      this.pdf.addPage();
      this.pageNumber += 1;
      this.y = this.starty;
      await this.addHeader(program_name);
      await this.addFooter(program_name);
      resolve('New Page Added');
    });
  }

  private async addHeader(program_name) {
    return new Promise((resolve, reject) => {
      this.y = 40; 
      this.x = 40;

      // Add Eisai Logo
      this.pdf.addImage(EISAI_LOGO, 'png', this.x, this.y, 130, 65); this.y += 20;

      // Eisai Top Right Info
      this.pdf.setFont("helvetica"); 
      this.pdf.setFontType("bold");
      this.pdf.setFontSize(14);
      this.pdf.text('PHONE:', this.x + 350, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('1-844-980-0410', this.x  + 415, this.y); this.y += 20;

      this.pdf.setFontType("bold");
      this.pdf.text('FAX:', this.x + 350, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('1-844-980-0416', this.x + 415, this.y); this.y += 20;

      this.pdf.setFontType("bold");
      this.pdf.text('EMAIL:', this.x + 350, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('info@eisaicares.ca', this.x + 415, this.y); this.y += 20;
      this.pdf.setFontType("normal"); 
      resolve();
    });
  }

  private addFooter(program_name)  {
    return new Promise((resolve, reject) => {
      // Footer with Clinic and Page Number
      this.pdf.setFontSize(12);
      this.pdf.line(this.x, this.pageHeight - 40, this.pageWidth - 40, this.pageHeight - 40);
      let nextline = program_name;
      // if(batch.order_batch) { nextline += ' - ' + batch.order_batch; }
      this.pdf.text(nextline, this.x, this.pageHeight - 25);
      // this.pdf.text(this.pageNumber.toString(), this.pageWidth - 60, this.pageHeight - 25);
      resolve('Footer Complete');
    });
  }

  private async uploadLettertoFirebase(program_id, program_name, patient, file: any, doc_type, user) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      const dt = new Date().getTime();
      const filename = `${dt}_Letter_${patient.program_patient_id}_${patient.last_name}.pdf`;
      filePath = 'documents/' + filename;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("File Upload Complete: ", file); 
          file['ext'] = 'pdf';
          file['url'] = u;
          file['doc_type'] = doc_type;
          file['mimetype'] = 'application/pdf';
          file['filename'] = filename;
          const patientnew = {
            id: patient.id,
            first_name: patient.first_name,
            last_name: patient.last_name,
            program_patient_id: patient.program_patient_id
          }
          this.db.addDocument(program_id, patientnew, file, user, 'Letter', doc_type)
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  private async uploadOrdertoFirebase(program_id, program_name, patient, file: any, doc_type, order_id, user) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      const dt = new Date().getTime();
      const filename = `${dt}_${order_id}_${patient.program_patient_id}_${patient.last_name}.pdf`;
      filePath = 'orders/' + filename;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("Order Upload Complete: ", file); 
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/pdf/pdf.ts